import { useSelector, useDispatch  } from 'react-redux'
import { useState } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TextField, NavigationList } from '@a-ui/react';
import { setViewMode } from '../../store/slices/viewModeReducer'
import { setSearch } from '../../store/slices/tasksReducer'
import { clear } from '../../store/slices/tasksReducer'
import '../../styles/nav.scss';


const Tabs = (props) => {
  const dispatch = useDispatch()
  const viewMode = useSelector(state => state.viewMode);
  const { search } = useSelector(state => state.tasks)
  const [searchinput, setSearchinput] = useState(search || '');
  const navigate = useNavigate();
  const location = useLocation();

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
    dispatch(setSearch(e.target.value))
    if(location.pathname !== "/") navigate('/');
    }
  };

  const onFocusOut = (e) => {
    dispatch(setSearch(e.target.value))
  };

  const onTabClick = (item) => {
    if (item === 'list') {
      dispatch(clear());
      dispatch(setViewMode("list"));
    } else if (item === 'map') {
      dispatch(setViewMode("map"))
    }
  }

  return <div className="u-hero-wrapper">
    <div className="u-flex">
      <div className={!!props.taskName ? "o-hero__search u-margin-bottom" : "o-hero__search u-margin-bottom-xs"}>
        <TextField
          addon={{
            content: 'search',
            placement: 'right',
            type: 'icon'
          }}
          value={searchinput}
          id="search-field"
          label="Zoeken"
          onKeyDown={onKeyDown}
          onBlur={onFocusOut}
          onChange={(e) => setSearchinput(e.target.value)}
        />
      </div>

      <div className="o-hero__main">
        {!!props.taskName && <>
          <ul className="a-breadcrumb u-margin-top-xs u-margin-bottom-xs">
            <li><Link to="/">Takenlijst</Link></li>
            <li>{props.taskName}</li>
          </ul>
          <h1>{props.taskName}</h1>
        </>}
        {!props.hideTabs && <>
          <NavigationList
            items={[
              {
                active: viewMode.name === "list",
                id: 'list',
                label: 'Takenlijst',
              },
              {
                active: viewMode.name === "map",
                id: 'map',
                label: 'Kaart',
              },
            ]}
            onItemClick={onTabClick}
          />
        </>}
      </div>
    </div>
  </div>
}

export default Tabs;
